import { T } from '@app/components/translation';

import style from './too-many-requests.module.scss';

type Props = {
  errorStatusCode: number | undefined;
};

export const TooManyRequests = ({ errorStatusCode }: Props) => {
  if (errorStatusCode !== 429 || errorStatusCode === undefined) {
    return null;
  }

  return (
    <div className={style.ErrorMessage}>
      <p className={style.ErrorHeader}>
        <T
          _str="An export is already ongoing."
          _comment="Error header in the agreement export modal."
        />
      </p>
      <p>
        <T
          _str="Please try again later."
          _comment="Empty state content. Shown in export modal when having no data."
        />
      </p>
    </div>
  );
};
